"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const store_1 = require("../../../store/store");
const ehdSlice_1 = require("../../../store/slices/ehdSlice");
const QuestionField_1 = __importDefault(require("./QuestionField"));
const YesNoModal_1 = __importDefault(require("../../../components/YesNoModal"));
const QuestionForm = ({ question, totalQuestions }) => {
    const { currentQuestionIndex, answers, showConfirm, blockedQuestions, blockedViewConfirmed } = (0, store_1.useAppSelector)((state) => state.ehd);
    const dispatch = (0, store_1.useAppDispatch)();
    const currentAnswer = (0, store_1.useAppSelector)((state) => (0, ehdSlice_1.getCurrentAnswerByQuestionId)(state)(question.id));
    let subQuestionDepth = 0;
    const requiredValidationText = yup.string().trim().required(__.trans('ehd.answer-required'));
    const formEl = (0, react_1.useRef)(null);
    const hasAnswer = (0, react_1.useMemo)(() => currentAnswer, [currentAnswer]);
    const shouldRender = (0, react_1.useCallback)((triggerAnswer) => {
        if (!triggerAnswer) {
            return false;
        }
        return currentAnswer !== undefined && triggerAnswer === (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.answer);
    }, [currentAnswer]);
    const processSubQuestions = (0, react_1.useCallback)((question, triggerAnswer, index) => {
        subQuestionDepth++;
        if (!shouldRender(triggerAnswer)) {
            return [];
        }
        return [
            question.id,
            ...question.subQuestions.flatMap((subQuestion) => processSubQuestions(subQuestion, subQuestion.triggerSubquestionsFor, index + 1)),
        ];
    }, [shouldRender, subQuestionDepth]);
    const activeQuestions = (0, react_1.useMemo)(() => {
        const active = [
            question.id,
            ...question.subQuestions.map((s) => processSubQuestions(s, question.triggerSubquestionsFor, 1)),
        ];
        return active.flat(subQuestionDepth).filter((x) => x);
    }, [
        processSubQuestions,
        question.id,
        question.subQuestions,
        question.triggerSubquestionsFor,
        subQuestionDepth,
    ]);
    const traverseTree = (action, question) => {
        const done = action(question);
        if (question.subQuestions.length === 0 || done) {
            return;
        }
        for (const subQ of question.subQuestions) {
            traverseTree(action, subQ);
        }
    };
    const questionIsActive = (questionId) => activeQuestions.findIndex((x) => x === questionId) !== -1;
    const createInitialValues = (question) => {
        const values = {};
        traverseTree((q) => {
            if (!questionIsActive(q.id))
                return;
            const existing = answers.find((a) => a.id === q.id);
            values[`answer-${q.id}`] = (existing === null || existing === void 0 ? void 0 : existing.answer) || '';
        }, question);
        return values;
    };
    const createValidationSchema = (question) => {
        const schema = {};
        traverseTree((q) => {
            if (!questionIsActive(q.id))
                return;
            schema[`answer-${q.id}`] = requiredValidationText;
        }, question);
        return schema;
    };
    const renderSubQuestions = (subQuestions, parentId, index) => subQuestions.map((subQuestion) => questionIsActive(subQuestion.id) ? ((0, jsx_runtime_1.jsxs)("div", { className: `ps-${index}`, children: [(0, jsx_runtime_1.jsx)(QuestionField_1.default, { question: subQuestion, parentId: parentId }), renderSubQuestions(subQuestion.subQuestions, subQuestion.id, index + 1)] }, `${subQuestion.id}_${index}`)) : (''));
    const getAnswerStatuses = () => {
        const statusData = [];
        traverseTree((question) => {
            const existing = answers.find((a) => (a === null || a === void 0 ? void 0 : a.id) === question.id);
            if (existing) {
                let status = '';
                switch (existing.answer) {
                    case 'YES':
                        status = question.answerStatusIfYes;
                        break;
                    case 'NO':
                        status = question.answerStatusIfNo;
                        break;
                    case 'MAYBE':
                        status = question.answerStatusIfYesNoMaybe;
                        break;
                    default:
                        break;
                }
                statusData.push(Object.assign({ status, answer: existing.answer }, question));
            }
        }, question);
        return statusData;
    };
    const handleSubmit = () => {
        const statusData = getAnswerStatuses();
        const blockedAnswers = statusData.filter((question) => question.status === 'BLOCK' || question.status === 'WARNING');
        if (blockedViewConfirmed) {
            dispatch((0, ehdSlice_1.setBlockedViewConfirmed)(false));
        }
        const inBlockedQuestions = blockedQuestions.find((q) => q.id === question.id);
        if (blockedAnswers.length && !inBlockedQuestions) {
            dispatch((0, ehdSlice_1.setBlockedQuestions)(blockedQuestions.concat(blockedAnswers)));
        }
        if (!blockedAnswers.length && inBlockedQuestions) {
            dispatch((0, ehdSlice_1.setBlockedQuestions)(blockedQuestions.filter((q) => q.id !== question.id)));
        }
        if (!showConfirm &&
            currentQuestionIndex !== -1 &&
            currentQuestionIndex === totalQuestions - 1) {
            dispatch((0, ehdSlice_1.setShowConfirm)(true));
        }
        if (currentQuestionIndex !== totalQuestions - 1) {
            dispatch((0, ehdSlice_1.setCurrentQuestionIndex)(currentQuestionIndex + 1));
            return;
        }
        if (currentQuestionIndex !== totalQuestions - 1) {
            dispatch((0, ehdSlice_1.setCurrentQuestionIndex)(currentQuestionIndex + 1));
            return;
        }
    };
    const cancelQuestionnaire = () => {
        dispatch((0, ehdSlice_1.resetState)());
    };
    const getCancelButton = () => ((0, jsx_runtime_1.jsx)(YesNoModal_1.default, { btnText: __.trans('ehd.cancel-questionnaire'), content: __.trans('ehd.confirm-cancel'), answerCb: cancelQuestionnaire, title: __.trans('ehd.cancel-modal-title') }));
    const previousButton = (0, react_1.useMemo)(() => currentQuestionIndex ? ((0, jsx_runtime_1.jsx)("button", { tabIndex: 0, type: "button", className: "btn btn-sm theme-button-primary me-1", onClick: () => dispatch((0, ehdSlice_1.setCurrentQuestionIndex)(currentQuestionIndex - 1)), children: __.trans('app.general_previous') })) : null, [currentQuestionIndex, dispatch]);
    const nextButton = (0, react_1.useMemo)(() => {
        const button = ((0, jsx_runtime_1.jsx)("button", { tabIndex: 0, type: "submit", className: "btn btn-sm me-1 theme-button-primary", children: __.trans('app.general_next') }));
        return button;
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (question && question.type === 'FREETEXT') {
            return;
        }
        if (currentAnswer &&
            (question.subQuestions.length === 0 ||
                currentAnswer.answer !== question.triggerSubquestionsFor) &&
            hasAnswer !== currentAnswer &&
            currentQuestionIndex < totalQuestions - 1) {
            (_a = formEl.current) === null || _a === void 0 ? void 0 : _a.submitForm();
        }
    }, [currentAnswer, question, currentQuestionIndex, hasAnswer, totalQuestions]);
    const hasHelpText = (0, react_1.useMemo)(() => question.questionExplanation.replace(/\\n/g, '').trim() !== '', [question]);
    return ((0, jsx_runtime_1.jsxs)("div", { id: "question-form", className: "ehd-container", children: [(0, jsx_runtime_1.jsx)(formik_1.Formik, { innerRef: formEl, initialValues: createInitialValues(question), onSubmit: handleSubmit, validationSchema: yup.object().shape(createValidationSchema(question)), enableReinitialize: true, children: (0, jsx_runtime_1.jsxs)(formik_1.Form, { children: [(0, jsx_runtime_1.jsx)(QuestionField_1.default, { question: question }), renderSubQuestions(question.subQuestions, question.id, 1), (0, jsx_runtime_1.jsxs)("div", { className: "py-1 d-flex justify-content-between flex-wrap gap-1", children: [(0, jsx_runtime_1.jsxs)("div", { className: "py-1 justify-content-between d-flex flex-wrap gap-1", children: [previousButton, nextButton] }), getCancelButton()] })] }) }), hasHelpText && ((0, jsx_runtime_1.jsxs)("div", { className: 'help-text', children: [(0, jsx_runtime_1.jsxs)("span", { className: "fw-bold d-block mb-2", children: [" ", __.trans('ehd.explanation')] }), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: question.questionExplanation } })] }))] }));
};
exports.default = QuestionForm;
